// French translations for all site content.
// Structure mirrors data.js — only the fields users read on screen.

export const BUSINESS_FR = {
  address: "Centre d'opérations provincial, Fredericton, N.-B., Canada",
  license:
    "Loi sur les enquêteurs et les services de sécurité privés du N.-B. — Licencié et assuré",
};

export const UI = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      cities: "Coverage",
      insights: "Insights",
      about: "Doctrine",
      contact: "Contact",
      cta: "Request Quote →",
      established: "Est. 2008",
    },
    common: {
      allServices: "All Services",
      allCities: "All Cities",
      requestQuote: "Request Quote",
      viewServices: "View Services",
      scroll: "Scroll",
      active: "Active",
      activePatrol: "Active Patrol",
      status: "Status",
      region: "Region",
      population: "Population",
      coords: "Coords",
    },
    footer: {
      sitemap: "[ Site Map · SEO Backlinks ]",
      protect: "Protecting",
      protectSub: "from Woodstock to Caraquet.",
      services: "Services",
      coverage: "Coverage",
      licensed: "Licensed · NB Class 2",
      dispatch: "24 / 7 / 365 Dispatch",
      rights: "All rights reserved.",
    },
    hero: {
      active: "Active Operations · Province of New Brunswick",
      line1: "Licensed security",
      line2: "guards across",
      line3: "New Brunswick.",
      chip: "[ 01 · New Brunswick Security Services ]",
      body:
        "Licensed uniformed guards, mobile patrol, event security, executive protection and 24/7 alarm response across every incorporated community in New Brunswick. Established 2008. Bilingual. Insured.",
    },
    lang: {
      toggleAria: "Toggle language",
      en: "EN",
      fr: "FR",
    },
    quote: {
      chip: "[ 04 · Request For Service ]",
      title1: "Deploy a",
      title2: "Guard.",
      intro:
        "Complete the operations brief and a licensed New Brunswick Security Services duty officer will contact you within one business hour with a written quote.",
      submit: "Transmit Request",
      submitting: "Transmitting…",
      success: "Request received.",
      successBody:
        "A duty officer will reach out to you within one business hour. You will receive a written quote at the email you provided.",
      another: "Submit Another",
      consent:
        "By submitting you consent to a bonded, insured NB Security Services officer contacting you.",
      fields: {
        name: "Full Name",
        email: "Email",
        phone: "Phone",
        city: "City",
        service: "Service Required",
        message: "Operations Brief",
      },
      placeholders: {
        message: "Site address, duration, hours, threat context…",
      },
    },
  },
  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      cities: "Couverture",
      insights: "Perspectives",
      about: "Doctrine",
      contact: "Contact",
      cta: "Demander un devis →",
      established: "Fondée en 2008",
    },
    common: {
      allServices: "Tous les services",
      allCities: "Toutes les villes",
      requestQuote: "Demander un devis",
      viewServices: "Voir les services",
      scroll: "Défiler",
      active: "Actif",
      activePatrol: "Patrouille active",
      status: "Statut",
      region: "Région",
      population: "Population",
      coords: "Coordonnées",
    },
    footer: {
      sitemap: "[ Plan du site · Liens SEO ]",
      protect: "Protégeant",
      protectSub: "de Woodstock à Caraquet.",
      services: "Services",
      coverage: "Couverture",
      licensed: "Licencié · Classe 2 N.-B.",
      dispatch: "Répartition 24 / 7 / 365",
      rights: "Tous droits réservés.",
    },
    hero: {
      active: "Opérations actives · Province du Nouveau-Brunswick",
      line1: "Agents de sécurité",
      line2: "licenciés dans tout le",
      line3: "Nouveau-Brunswick.",
      chip: "[ 01 · Services de sécurité du Nouveau-Brunswick ]",
      body:
        "Agents en uniforme licenciés, patrouille mobile, sécurité événementielle, protection rapprochée et intervention 24/7 sur alarme dans chaque communauté constituée du Nouveau-Brunswick. Fondée en 2008. Bilingue. Assurée.",
    },
    lang: {
      toggleAria: "Changer de langue",
      en: "EN",
      fr: "FR",
    },
    quote: {
      chip: "[ 04 · Demande de service ]",
      title1: "Déployez un",
      title2: "agent.",
      intro:
        "Remplissez le formulaire ci-dessous et un agent de garde licencié des Services de sécurité du Nouveau-Brunswick vous contactera avec un devis écrit dans l'heure ouvrable.",
      submit: "Transmettre la demande",
      submitting: "Transmission…",
      success: "Demande reçue.",
      successBody:
        "Un agent de garde vous contactera dans l'heure ouvrable. Vous recevrez un devis écrit à l'adresse courriel fournie.",
      another: "Envoyer une autre",
      consent:
        "En soumettant, vous consentez à ce qu'un agent des SS du N.-B. cautionné et assuré vous contacte.",
      fields: {
        name: "Nom complet",
        email: "Courriel",
        phone: "Téléphone",
        city: "Ville",
        service: "Service requis",
        message: "Brief d'opérations",
      },
      placeholders: {
        message: "Adresse du site, durée, horaires, contexte de menace…",
      },
    },
  },
};

// French translations for each service (name + tagline + summary).
// Long-form and bullets stay in English to preserve the extensive SEO copy
// unless the user is browsing FR — in which case a French summary is shown.
export const SERVICES_FR = {
  "uniformed-security-guards": {
    name: "Agents de sécurité en uniforme",
    tagline: "Dissuasion visible. Personnel formé. Postes 24/7.",
    summary:
      "Agents en uniforme licenciés provincialement pour les sites commerciaux, industriels, de vente au détail et résidentiels du Nouveau-Brunswick — couverture jour, nuit, weekend et jours fériés.",
  },
  "mobile-patrol": {
    name: "Patrouille mobile",
    tagline: "Véhicules identifiés. Contrôles aléatoires. Couverture provinciale.",
    summary:
      "Véhicules de patrouille identifiés géolocalisés effectuant des vérifications aléatoires sur votre propriété — reconnu pour réduire les cambriolages et le vandalisme jusqu'à 68 %.",
  },
  "event-security": {
    name: "Sécurité événementielle",
    tagline: "Festivals, mariages, concerts, événements corporatifs.",
    summary:
      "Sécurité événementielle certifiée pour la gestion des foules, le contrôle d'accès, l'escorte VIP et l'intervention d'urgence — de Harvest Jazz aux galas privés.",
  },
  "construction-site-security": {
    name: "Sécurité de chantier",
    tagline: "Vol de cuivre, perte d'outils, intrusion — résolus.",
    summary:
      "Postes d'agents de nuit, patrouilles mobiles et tours CCTV mobiles pour les chantiers du Nouveau-Brunswick. Dissuasion approuvée par les assureurs.",
  },
  "residential-security": {
    name: "Sécurité résidentielle",
    tagline: "Domaines, condos, communautés fermées, résidences privées.",
    summary:
      "Conciergerie résidentielle, patrouille itinérante et protection de domaines pour les familles fortunées et les conseils de condominiums à travers le Nouveau-Brunswick.",
  },
  "commercial-retail-security": {
    name: "Sécurité commerciale et vente au détail",
    tagline: "Prévention des pertes, ouverture/fermeture, agents en civil.",
    summary:
      "Sécurité de magasins, agents de prévention des pertes en civil et gardiennage commercial après les heures pour les entreprises du Nouveau-Brunswick.",
  },
  "concierge-security": {
    name: "Sécurité de conciergerie",
    tagline: "Première impression. Dernière défense.",
    summary:
      "Sécurité de conciergerie pour hôtels, halls corporatifs et immeubles résidentiels de luxe — le mélange transparent d'hospitalité et de protection.",
  },
  "corporate-security": {
    name: "Sécurité corporative",
    tagline: "Étages exécutifs. Réception. Protection des salles de conseil.",
    summary:
      "Agents de sécurité corporative, protection rapprochée et prévention de la violence en milieu de travail pour les sièges sociaux et campus du Nouveau-Brunswick.",
  },
  "loss-prevention": {
    name: "Prévention des pertes",
    tagline: "Réduction du shrink. Arrestations recevables au tribunal.",
    summary:
      "Agents en civil, enquêtes de vol interne et audits d'inventaire pour les détaillants du Nouveau-Brunswick.",
  },
  "alarm-response": {
    name: "Intervention sur alarme",
    tagline: "Premier sur les lieux. Toujours. À toute heure.",
    summary:
      "Intervention sur alarme licenciée 24/7 et service de porteur de clés pour les entreprises et résidences du Nouveau-Brunswick.",
  },
  "vip-executive-protection": {
    name: "Protection VIP et exécutive",
    tagline: "Protection rapprochée discrète. Planification préalable.",
    summary:
      "Agents de protection rapprochée, transport terrestre sécurisé et sécurité de voyage préalable pour les VIP visitant ou résidant au Nouveau-Brunswick.",
  },
  "fire-watch": {
    name: "Garde-feu",
    tagline: "Axé conformité. Approuvé par les assureurs.",
    summary:
      "Agents de garde-feu déployés lorsque votre système de gicleurs ou d'alarme incendie est hors service — conforme NFPA et Bureau du prévôt des incendies du N.-B.",
  },
  "parking-enforcement": {
    name: "Application du stationnement",
    tagline: "Contraventions conformes aux règlements. Remorquage autorisé. Équitable.",
    summary:
      "Application du stationnement sur propriété privée, contraventions et autorisation de remorquage pour les propriétaires et gestionnaires du N.-B.",
  },
  "cctv-monitoring": {
    name: "Surveillance CCTV",
    tagline: "Yeux en direct. Alertes IA. Vérification humaine.",
    summary:
      "Surveillance vidéo en direct à distance, alertes déclenchées par IA, tournées virtuelles d'agents et revue judiciaire post-incident pour les propriétés du N.-B.",
  },
  "mining-security": {
    name: "Sécurité minière",
    tagline: "Protection de fosse. Contrôle de camp. Garde de minerai à haute valeur.",
    summary:
      "Sécurité spécialisée pour les sites miniers du Nouveau-Brunswick, les installations de traitement du minerai, les camps d'exploration et les corridors de camionnage — des opérations de potasse à Sussex aux gisements de métaux de base du camp minier de Bathurst.",
  },
};

// Short FR intros per city (2 sentences max).
export const CITIES_FR = {
  "fredericton": "Capitale du Nouveau-Brunswick. Notre équipe protège les installations gouvernementales, le commerce de détail, les domaines résidentiels et les événements publics dans toute la région de la capitale.",
  "saint-john": "La plus ancienne ville constituée du Canada et le plus grand pôle industriel du N.-B. Notre division Saint-Jean se spécialise dans la protection portuaire, industrielle et corporative le long de la baie de Fundy.",
  "moncton": "Pôle commercial et de transport des Maritimes. Notre équipe de Moncton livre prévention des pertes, sécurité événementielle, soutien au casino et protection corporative.",
  "dieppe": "Officiellement bilingue et en croissance rapide. Nous fournissons des agents en uniforme francophones, PP au détail et sécurité de chantier à travers Dieppe.",
  "riverview": "Le complément résidentiel paisible à Moncton et Dieppe. Les familles de Riverview nous confient patrouille domiciliaire, protection de domaine et sécurité d'événement.",
  "miramichi": "Capitale mondiale de la pêche au saumon. Notre division Miramichi se spécialise en protection de sites industriels, sécurité hospitalière et patrouille mobile rurale.",
  "edmundston": "Cœur de la République du Madawaska. Nous fournissons agents francophones, sécurité industrielle et protection événementielle.",
  "bathurst": "Centre de service du nord du N.-B. sur la baie des Chaleurs. Notre équipe Bathurst couvre sécurité industrielle, hospitalière et événementielle.",
  "campbellton": "Porte d'entrée entre le N.-B. et la péninsule gaspésienne du Québec. Logistique transfrontalière, santé et tourisme extérieur guident nos opérations.",
  "oromocto": "Hôte de la BFC Gagetown. Notre équipe Oromocto comprend d'anciens membres des FAC et se spécialise en périmètre et sécurité de chantier autour de la base.",
  "sackville": "Ville universitaire pittoresque à la frontière avec la Nouvelle-Écosse. Sécurité de campus, événements étudiants et protection de domaines résidentiels.",
  "sussex": "Capitale laitière du N.-B. et hôte du célèbre Festival des Montgolfières. Notre équipe couvre événements du festival, sites agricoles et opérations minières.",
  "woodstock": "Centre de service du comté de Carleton et porte vers le Maine. Camionnage transfrontalier, agriculture et commerce rural définissent nos opérations.",
  "grand-bay-westfield": "Ville dortoir tranquille au nord-ouest de Saint-Jean. Patrouille résidentielle, protection de marina et sécurité de domaine.",
  "quispamsis": "Une des communautés à croissance la plus rapide du N.-B. Nous protégeons familles, communautés fermées et événements du Qplex.",
  "rothesay": "Historiquement la banlieue la plus prospère de Saint-Jean. Nous fournissons protection de domaine discrète et services de protection rapprochée familiale.",
  "shediac": "Capitale mondiale du homard et aimant touristique estival. Notre division gère contrôle de foule du Festival du homard, assistance de plage et sécurité de chalets.",
  "caraquet": "Capitale culturelle de l'Acadie. Notre équipe entièrement bilingue se spécialise en sécurité de festival, protection portuaire et couverture du Village Historique.",
  "beresford": "Communauté côtière bilingue sur la baie des Chaleurs. Notre équipe gère patrouille d'événements en front de plage, protection de marina et couverture résidentielle.",
  "belledune": "Port en eau profonde et pilier industriel du nord du N.-B. Sécurité industrielle spécialisée jour et nuit.",
  "dalhousie": "Ville historique bilingue sur la rivière Restigouche. Nous fournissons sécurité logistique transfrontalière, front d'eau et couverture d'événements.",
  "atholville": "Petite communauté industrielle adjacente à Campbellton. Notre équipe sécurise l'usine AV Cell, corridors transfrontaliers et propriétés rurales.",
  "tide-head": "Village tranquille du Restigouche où la marée rencontre enfin la rivière. Patrouille résidentielle et sécurité d'événements récréatifs.",
  "kedgwick": "Communauté forestière francophone dans les hautes terres du Restigouche. Sécurité bilingue de sites d'usines et intervention rurale sur alarme.",
  "saint-quentin": "Capitale du sirop d'érable du Canada atlantique. Sécurité d'événements bilingues, protection forestière et patrouille rurale.",
  "saint-leonard": "Village frontalier francophone en face de Van Buren, Maine. Logistique transfrontalière, sites agricoles et commerce bilingue.",
  "grand-falls": "Ville bilingue enveloppée autour d'une des cascades les plus spectaculaires de l'Est du Canada. Tourisme, logistique de l'industrie de la pomme de terre et sécurité hospitalière.",
  "haut-madawaska": "Région francophone nouvellement fusionnée à la frontière du Québec. Sécurité transfrontalière bilingue, protection de sites forestiers et patrouille rurale.",
  "perth-andover": "Village jumeau enjambant la rivière Saint-Jean dans le comté de Victoria. Sécurité agricole, périmètre hydro et événements communautaires.",
  "plaster-rock": "Foyer Tobique-Nictau du Championnat mondial de hockey d'étang. Sécurité d'événements hivernaux et patrouille mobile rurale.",
  "florenceville-bristol": "Siège mondial de McCain Foods et « Capitale mondiale de la frite ». Sécurité de siège corporatif, protection de sites agroalimentaires et escorte exécutive.",
  "hartland": "Foyer du plus long pont couvert au monde et communauté agricole riche. Protection de sites patrimoniaux, sécurité agricole et couverture touristique.",
  "nackawic": "Foyer de la Plus Grande Hache du Monde et grande usine de pâte sur la rivière Saint-Jean. Sécurité de site d'usine et logistique forestière.",
  "mcadam": "Ville ferroviaire historique à la frontière du Maine. Logistique transfrontalière, sécurité de gare de triage et protection patrimoniale.",
  "harvey": "Communauté rurale au sud de Fredericton célèbre pour ses lacs et son patrimoine agricole. Chalet, marina et sécurité de domaine.",
  "stanley": "Village rural au nord de Fredericton dans la vallée du Nashwaak. Logistique forestière, sites agricoles et événements communautaires.",
  "doaktown": "Capitale du saumon atlantique sur la rivière Miramichi. Protection de camps de pêche, sécurité d'événements et patrouille mobile rurale.",
  "blackville": "Village historique de pêche au saumon le long du Miramichi. Protection de camps et services de patrouille rurale.",
  "neguac": "Village de pêche francophone sur la baie de Miramichi. Sécurité portuaire bilingue, protection de marina et couverture événementielle saisonnière.",
  "rogersville": "Communauté francophone célébrée pour son héritage acadien. Nous livrons sécurité d'événements bilingues et patrouille rurale.",
  "richibucto": "Ville de pêche bilingue porte du parc national de Kouchibouguac. Notre équipe gère la sécurité touristique adjacente au parc.",
  "bouctouche": "Bijou touristique acadien du comté de Kent et lieu de naissance de KC Irving. Sécurité d'événements bilingues et protection de sites touristiques.",
  "cap-acadie": "Région côtière acadienne nouvellement fusionnée incluant Cap-Pelé. Sécurité d'événements saisonniers bilingues, protection des pêcheries et patrouille de plage.",
  "memramcook": "Berceau de la Renaissance acadienne. Protection de sites patrimoniaux, sécurité d'événements bilingues et patrouille rurale.",
  "salisbury": "Village dortoir en croissance à l'ouest de Moncton le long de la Transcanadienne. Vente au détail, logistique et sécurité résidentielle.",
  "petitcodiac": "Village historique de Westmorland sur la Transcanadienne. Protection patrimoniale, sécurité de sites agricoles et patrouille rurale.",
  "hillsborough": "Village historique du comté d'Albert sur le Petitcodiac. Sécurité de sites patrimoniaux, protection d'attractions touristiques et patrouille rurale.",
  "alma": "Porte du parc national Fundy et des plus hautes marées du monde. Sécurité touristique adjacente au parc, protection de chalets et couverture d'événements saisonniers.",
  "riverside-albert": "Village de Fundy tranquille près du cap Enrage. Sécurité de sites touristiques, patrouille côtière et protection de domaine.",
  "hampton": "Chef-lieu du comté de Kings sur la rivière Kennebecasis. Domaines résidentiels, sécurité adjacente au palais de justice et événements communautaires.",
  "norton": "Village rural du comté de Kings près du Kennebecasis. Protection de domaine, sites agricoles et patrouille mobile rurale.",
  "chipman": "Village forestier du comté de Queens sur la rivière Salmon. Sécurité de site d'usine, logistique forestière et patrouille rurale.",
  "minto": "Communauté du comté de Queens avec un patrimoine minier profond sur le Grand Lac. Sécurité de sites industriels et patrouille rurale.",
  "cambridge-narrows": "Communauté lacustre du comté de Queens. Sécurité de chalets, protection de marina et patrouille de domaine le long du lac Washademoak.",
  "saint-andrews": "Ville de villégiature historique du comté de Charlotte — « Saint Andrews by-the-Sea ». Sécurité de complexe de luxe, protection patrimoniale et couverture yacht.",
  "saint-george": "Ville historique du comté de Charlotte célèbre pour sa gorge fluviale dramatique. Protection de sites industriels, logistique maritime et sécurité patrimoniale.",
  "saint-stephen": "« Ville du chocolat du Canada » et poste frontalier occupé avec Calais, Maine. Sécurité de siège corporatif, logistique transfrontalière et PP au détail.",
  "campobello-island": "L'île de Fundy où Franklin Roosevelt passait l'été. Sécurité touristique transfrontalière, protection patrimoniale et patrouille insulaire.",
  "shippagan": "Pôle scientifique et éducatif de la Péninsule acadienne. Sécurité de campus bilingue, couverture d'événements de l'aquarium et protection des quais de pêche.",
  "lameque": "Pointe insulaire de la Péninsule acadienne et hôte du Festival international de musique baroque. Sécurité d'événements bilingues et protection industrielle des tourbières.",
  "tracadie": "Centre de service de la Péninsule acadienne. Sécurité hospitalière bilingue, PP au détail, couverture d'événements et protection de sites industriels.",
  "bas-caraquet": "Village de pêche francophone adjacent à Caraquet. Sécurité portuaire bilingue, protection de flotte et couverture d'événements.",
  "petit-rocher": "Village francophone sur la côte des Chaleurs célébrant son patrimoine minier. Sécurité d'événements bilingues et de communauté côtière.",
  "nigadoo": "Communauté francophone tranquille sur la baie des Chaleurs. Patrouille résidentielle et protection de petites entreprises avec agents bilingues.",
  "balmoral": "Communauté rurale du Restigouche avec un moulin à grains historique du 19e siècle. Sécurité de sites patrimoniaux, protection agricole et patrouille rurale.",
  "eel-river-crossing": "Village côtier du Restigouche sur l'une des plus grandes barres de sable naturelles du N.-B. Sécurité d'événements de plage et de chalets.",
  "hanwell": "Communauté rurale en croissance rapide immédiatement à l'ouest de Fredericton. Protection de domaines résidentiels, corridor commercial et sécurité de chantier.",
  "new-maryland": "Village résidentiel prospère au sud de Fredericton. Protection de domaine, sécurité familiale et couverture d'événements communautaires.",
};

// FR labels for city sectors so they display nicely.
export const CITY_SECTORS_FR_HEADING = "Secteurs que nous protégeons";
export const CITY_LANDMARKS_FR_HEADING = "Points de repère";

export const MANIFESTO_FR = [
  {
    number: "01",
    title: "La Doctrine",
    body:
      "La protection n'est pas un produit ; c'est une discipline. Chaque agent que nous déployons au Nouveau-Brunswick est formé, testé et re-testé selon la même norme mesurable. La discipline est ce qui transforme un uniforme en dissuasion.",
  },
  {
    number: "02",
    title: "Contrôle du périmètre",
    body:
      "Le premier acte hostile est le franchissement d'une ligne. Nous cartographions le périmètre de chaque client — physique, numérique, comportemental — et nous le tenons. L'accès est un privilège, accordé délibérément, révoqué instantanément.",
  },
  {
    number: "03",
    title: "Réponse tactique",
    body:
      "Quand le protocole devient crise, les secondes décident des résultats. Nos protocoles d'intervention sont exercés mensuellement et audités trimestriellement. Nous n'improvisons pas sous pression — nous exécutons.",
  },
  {
    number: "04",
    title: "Discrétion absolue",
    body:
      "La protection la plus efficace est la présence que vous n'avez jamais remarquée. La confidentialité est contractuelle, culturelle et non négociable. Vos opérations, vos gens, votre réputation — protégés en silence.",
  },
];

export const FAQ_FR = [
  {
    q: "Êtes-vous licenciés pour opérer partout au Nouveau-Brunswick ?",
    a: "Oui. Services de sécurité du Nouveau-Brunswick détient une licence provinciale d'entreprise de services de sécurité en vertu de la Loi sur les enquêteurs et les services de sécurité privés, et chaque agent détient une licence individuelle de travailleur de sécurité de Classe 2. Nous opérons légalement dans chaque communauté constituée du N.-B.",
  },
  {
    q: "À quelle vitesse pouvez-vous déployer ?",
    a: "Le déploiement standard se fait dans les 4 heures partout au N.-B., et aussi peu que 90 minutes à Fredericton, Saint-Jean et Moncton. L'intervention d'urgence sur alarme est en moyenne de 12 minutes urbain, 25 minutes rural.",
  },
  {
    q: "Offrez-vous des agents bilingues (anglais / français) ?",
    a: "Absolument. Environ 40 % de notre effectif est entièrement bilingue. Nous dotons par défaut les contrats de la Péninsule acadienne, du Madawaska, de Dieppe et de Caraquet avec des agents francophones.",
  },
  {
    q: "Vos gardes sont-ils armés ?",
    a: "Non. La réglementation du N.-B. restreint les armes à feu dans le travail de sécurité aux applications spécifiques de véhicules blindés et à haut risque. Nos agents en uniforme portent radios, matraques lorsque certifiés et formation à la désescalade.",
  },
  {
    q: "Quelle assurance détenez-vous ?",
    a: "Nous maintenons 5 000 000 $ en responsabilité civile générale commerciale, 5 000 000 $ en erreurs et omissions professionnelles, et couverture WorkSafeNB complète pour chaque agent. Certificats fournis sur demande.",
  },
  {
    q: "Pouvez-vous vous adapter pour de grands événements ?",
    a: "Oui. Notre plus grand déploiement récent impliquait 84 agents sur un festival de trois jours. Nous maintenons un effectif à temps partiel de 400 personnes pour les pointes d'événements dans le Canada atlantique.",
  },
];
